import Button from '@material-ui/core/Button'
import classes from '../styles.module.scss'
import React from 'react'
import { DownloadButton } from '../../../../uiKit/icons/Icons'
import { BASE_URL } from '../../../../configs'
import { alertError, alertSuccess, createJsonHeaders } from '../../../../api'

interface GeneratingContactsRiskResultsButtonExcelProps {
  botId: number
}

export const GeneratingContactsRiskAssessmentQuestionnaireButtonExcel: React.FC<GeneratingContactsRiskResultsButtonExcelProps> = ({
  botId,
}) => {
  const onClickHandler = () => {
    return fetch(`${BASE_URL}/bot/${botId}/risk-assessment/users-history`, {
      credentials: 'include',
      headers: createJsonHeaders(),
      method: 'POST'
    })
      .then(res => res.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'Contacts_Risk_Assessment_Questionnaire.xlsx'
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)

        alertSuccess('Risk Assessment Questionnaire downloaded successfully!')
      })
      .catch(() => {
        alertError('Sorry but something going wrong at downloading Risk Assessment Questionnaire, please ping support!')
      })
  }
  return (
    <>
      <Button className={classes.generateFeedbacksButton} onClick={onClickHandler} variant="raised">
        <DownloadButton height="13px" width="13px" color="#FFFFFF" />
      </Button>
      <p className={classes.addTitle}>Download Risk Assessment Questionnaire</p>
    </>
  )
}
